"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyRecommender = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var performance_1 = require("../../model/performance");
var service_1 = require("../../../library/base/service");
var MyRecommender = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyRecommender, _super);
    function MyRecommender() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的推荐人初始化接口';
        _this.code = '101029';
        _this.desc = '我的推荐人初始化接口';
        _this.requestParams = new performance_1.MyRecommenderRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyRecommender;
}(service_1.BaseService));
exports.MyRecommender = MyRecommender;
//# sourceMappingURL=myRecommender.js.map